<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: utils.in_rem(8px);
    .page-numbers {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: utils.in_rem(4px);
    }
  }
</style>

<script>
  import Button from "../../atoms/Button.svelte";
  import IconScale from "../../atoms/IconScale.svelte";
  import PageNumber from "./PageNumber.svelte";

  let { pageNumbers = $bindable([1]), page = $bindable(1) } = $props();

  let numberOfPages = $derived(pageNumbers.length);
  let lastPageNumber = $derived(pageNumbers[numberOfPages - 1]);

  let leftDisabled = $derived(pageNumbers.indexOf(page) === 0);
  let rightDisabled = $derived(pageNumbers.indexOf(page) === numberOfPages - 1);

  const updatePage = (delta) => {
    const index = pageNumbers.indexOf(page);
    if (index + delta >= 0 && index + delta < numberOfPages) {
      page = pageNumbers[index + delta];
    }
  };
</script>

{#snippet dots(index, number, refIndex, refNumber)}
  {#if index === refIndex && number !== refNumber}
    <IconScale class="fa-ellipsis" size="xs" color="textGrey" />
  {/if}
{/snippet}

<div class="pagination">
  <Button
    kind="ghost-grey"
    leadingIcon="fa-chevron-left"
    size="xs"
    style="width: 2rem;"
    onclick={() => updatePage(-1)}
    disabled={leftDisabled}
    class={leftDisabled ? "disabled" : ""}
  />
  <div class="page-numbers">
    {#each pageNumbers as number, index}
      {@const active = number === page}
      {@render dots(index, number, 1, 2)}
      <PageNumber
        {number}
        {active}
        onclick={() => {
          page = number;
        }}
      />
      {@render dots(index, number, numberOfPages - 2, lastPageNumber - 1)}
    {/each}
  </div>
  <Button
    kind="ghost-grey"
    leadingIcon="fa-chevron-right"
    size="xs"
    style="width: 2rem;"
    onclick={() => updatePage(1)}
    disabled={rightDisabled}
    class={rightDisabled ? "disabled" : ""}
  />
</div>
